import { Component,OnInit,OnDestroy,AfterViewInit } from '@angular/core';
import { NgbModal,NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { takeWhile } from "rxjs/operators";

import {
    FvmsCommonService
} from "src/app/shared/service";
import {
    DtgListType
} from "src/app/shared/vo";

@Component({
    templateUrl: './dtg.manage.car.ext.main.main.component.html'
    ,styleUrls: ["./dtg.manage.car.ext.main.main.component.scss"]
    ,providers: []
})
export class DtgManageCarExtMainMainComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    companyInfo:any;
    dayDiff:number=0;
    DtgListType = DtgListType;
    
    constructor(
        private modalService: NgbModal
        ,private fvmsCommonService:FvmsCommonService
    ) {
        this.companyInfo = this.fvmsCommonService.getCompanyInfo();

        this.fvmsCommonService.subscribeCompanyInfo()
        .pipe(takeWhile(() => this.isContinue))
        .subscribe(companyInfo => {
            this.companyInfo = companyInfo;
        });
     }

    ngOnInit() {
        
    }

    ngOnDestroy() {
        this.isContinue = false;
    }
    
    ngAfterViewInit() {
        
    }
}